import React from 'react'

import './cardME.css'

import {MdOutlineVideoLibrary} from 'react-icons/md'

export default function CardME({name,video,picture,tags,description}) {
  return (
    <div className='CardME'>
      <h2 className='CardMETitle'>{name}</h2>
      <img src={picture} className='ProjectMEImg' alt='ProjectMEImg'/>
      <p className='CardMEDiscription'>{description}</p>
      <div className='CardMETags'>
        {
          tags.map((tag,i) => (
            <span key={i} className='tagMEText'>{tag}</span>
          ))
        }
      </div>
      { video && <div className='CardMEBtns'>
        <a href={video} className='VideoMEBtn'><MdOutlineVideoLibrary/></a>
      </div>}
    </div>
  )
}